import React, { useState, useEffect } from "react";
import { Container, Card, Form, Row, Col, Button, Spinner, InputGroup } from "react-bootstrap";
import { api } from "../../services/api";
import Menu from "../../comum/Menu";
import Footer from "../../comum/Footer";
import Swal from "sweetalert2";

function ComunicadoOcorrencia() {
    const [loading, setLoading] = useState(false);
    const [loadingUser, setLoadingUser] = useState(false);
    const [lojas, setLojas] = useState([]);
    const [fotosBase64, setFotosBase64] = useState([]);

    const [dadosFuncionario, setDadosFuncionario] = useState({
        chapa: "",
        nome: "",
        funcao: "",
        secao: ""
    });

    const [formData, setFormData] = useState({
        classificacao: "",
        cod_emp: "",
        razao: "",
        data_ocorr: "",
        hora_ocorr: "",
        descricao: "",
        local: "",
        agente: "",
        parte: "",
        lado: "N/A",
        medico_externo: "NÃO"
    });

    useEffect(() => {
        buscarLojas();
    }, []);

    const buscarLojas = async () => {
        try {
            const resLojas = await api.get("/usuario/loja");
            setLojas(resLojas.data);
        } catch (err) {
            console.error("Erro ao carregar lojas");
        }
    };

    const buscarFuncionario = async (chapaDigitada) => {
        if (!chapaDigitada) {
            setDadosFuncionario({ chapa: "", nome: "", funcao: "", secao: "" });
            return;
        }

        setLoadingUser(true);
        try {
            const res = await api.get(`/usuario/dados/${chapaDigitada}`);
            const data = Array.isArray(res.data) ? res.data[0] : res.data;

            if (data && data.nome) {
                setDadosFuncionario({
                    chapa: data.chapa,
                    nome: data.nome,
                    funcao: data.funcao,
                    secao: data.secao
                });
            } else {
                setDadosFuncionario({ chapa: chapaDigitada, nome: "", funcao: "", secao: "" });
                Swal.fire("Aviso", "Funcionário não localizado.", "warning");
            }
        } catch (err) {
            setDadosFuncionario({ chapa: chapaDigitada, nome: "", funcao: "", secao: "" });
            Swal.fire("Erro", "Não foi possível localizar esta matrícula.", "error");
        } finally {
            setLoadingUser(false);
        }
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        if (files.length + fotosBase64.length > 5) {
            Swal.fire("Aviso", "Máximo de 5 fotos permitido", "warning");
            return;
        }

        files.forEach(file => {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFotosBase64(prev => [...prev, reader.result.split(',')[1]]);
            };
            reader.readAsDataURL(file);
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!dadosFuncionario.nome) {
            return Swal.fire("Atenção", "Busque uma matrícula válida antes de enviar.", "warning");
        }

        setLoading(true);
        const payload = {
            ...formData,
            chapa: dadosFuncionario.chapa,
            nome: dadosFuncionario.nome,
            funcao: dadosFuncionario.funcao,
            secao: dadosFuncionario.secao,
            usuario_logado: localStorage.getItem("nome"),
            fotos: fotosBase64
        };

        try {
            await api.post("/rh/ocorrencia", payload);
            Swal.fire("Sucesso", "Comunicado enviado com sucesso!", "success");
            
            setFotosBase64([]);
            setDadosFuncionario({ chapa: "", nome: "", funcao: "", secao: "" });
            setFormData({
                classificacao: "", cod_emp: "", razao: "", data_ocorr: "",
                hora_ocorr: "", descricao: "", local: "", agente: "",
                parte: "", lado: "N/A", medico_externo: "NÃO"
            });
        } catch (err) {
            Swal.fire("Erro", "Falha ao registrar ocorrência.", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: '#f4f7f6' }}>
            <Menu modulo="ARBOR" />
            
            {/* Adicionado mt-5 e pt-4 para evitar que o Menu fixo esconda o título */}
            <Container className="flex-grow-1 mt-5 pt-4 pb-5">
                <Card className="shadow-sm border-0">
                    <Card.Header className="bg-primary text-white fw-bold py-3">
                        <h5 className="mb-0">COMUNICADO DE OCORRÊNCIA</h5>
                    </Card.Header>
                    <Card.Body className="p-4">
                        <Form onSubmit={handleSubmit}>
                            <h6 className="text-primary fw-bold border-bottom pb-2 mb-4">DADOS DO COLABORADOR</h6>
                            <Row className="gy-3 mb-4">
                                <Col md={3}>
                                    <Form.Label className="fw-bold">MATRÍCULA (CHAPA)</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            placeholder="Ex: 012345"
                                            value={dadosFuncionario.chapa}
                                            onChange={e => setDadosFuncionario({...dadosFuncionario, chapa: e.target.value})}
                                            onBlur={e => buscarFuncionario(e.target.value)}
                                        />
                                        {loadingUser && (
                                            <InputGroup.Text>
                                                <Spinner animation="border" size="sm" />
                                            </InputGroup.Text>
                                        )}
                                    </InputGroup>
                                </Col>
                                <Col md={3}>
                                    <Form.Label className="fw-bold">NOME</Form.Label>
                                    <Form.Control readOnly value={dadosFuncionario.nome} className="bg-light" placeholder="Aguardando busca..." />
                                </Col>
                                <Col md={3}>
                                    <Form.Label className="fw-bold">FUNÇÃO</Form.Label>
                                    <Form.Control readOnly value={dadosFuncionario.funcao} className="bg-light" />
                                </Col>
                                <Col md={3}>
                                    <Form.Label className="fw-bold">SETOR</Form.Label>
                                    <Form.Control readOnly value={dadosFuncionario.secao} className="bg-light" />
                                </Col>
                            </Row>

                            <h6 className="text-primary fw-bold border-bottom pb-2 mb-4">DETALHES DA OCORRÊNCIA</h6>
                            <Row className="gy-3">
                                <Col md={6}>
                                    <Form.Label className="fw-bold">1. CLASSIFICAÇÃO DA OCORRÊNCIA</Form.Label>
                                    <Form.Select required value={formData.classificacao} onChange={e => setFormData({...formData, classificacao: e.target.value})}>
                                        <option value="">Selecione...</option>
                                        <option value="INCIDENTE">INCIDENTE</option>
                                        <option value="ACIDENTE SEM AFASTAMENTO">ACIDENTE SEM AFASTAMENTO</option>
                                        <option value="ACIDENTE COM AFASTAMENTO">ACIDENTE COM AFASTAMENTO</option>
                                        <option value="ATENDIMENTO AMBULATORIAL">ATENDIMENTO AMBULATORIAL</option>
                                    </Form.Select>
                                </Col>
                                <Col md={6}>
                                    <Form.Label className="fw-bold">6. LOJA (LOCAL DO ACIDENTE)</Form.Label>
                                    <Form.Select required value={formData.cod_emp} onChange={e => {
                                        const lj = lojas.find(x => x.cod_emp == e.target.value);
                                        setFormData({...formData, cod_emp: e.target.value, razao: lj?.razao || ""});
                                    }}>
                                        <option value="">Selecione a Loja...</option>
                                        {lojas.map(l => <option key={l.cod_emp} value={l.cod_emp}>{l.razao}</option>)}
                                    </Form.Select>
                                </Col>
                                <Col md={3}>
                                    <Form.Label className="fw-bold">7. DATA DA OCORRÊNCIA</Form.Label>
                                    <Form.Control type="date" required value={formData.data_ocorr} onChange={e => setFormData({...formData, data_ocorr: e.target.value})} />
                                </Col>
                                <Col md={3}>
                                    <Form.Label className="fw-bold">8. HORA DA OCORRÊNCIA</Form.Label>
                                    <Form.Control type="time" required value={formData.hora_ocorr} onChange={e => setFormData({...formData, hora_ocorr: e.target.value})} />
                                </Col>
                                <Col md={12}>
                                    <Form.Label className="fw-bold">9. DESCRIÇÃO DA OCORRÊNCIA</Form.Label>
                                    <Form.Control as="textarea" rows={3} required value={formData.descricao} onChange={e => setFormData({...formData, descricao: e.target.value})} />
                                </Col>
                                <Col md={4}><Form.Label className="fw-bold">10. LOCAL EXATO</Form.Label><Form.Control required value={formData.local} onChange={e => setFormData({...formData, local: e.target.value})} /></Col>
                                <Col md={4}><Form.Label className="fw-bold">11. AGENTE CAUSADOR</Form.Label><Form.Control required value={formData.agente} onChange={e => setFormData({...formData, agente: e.target.value})} /></Col>
                                <Col md={4}><Form.Label className="fw-bold">12. PARTE DO CORPO ATINGIDA</Form.Label><Form.Control required value={formData.parte} onChange={e => setFormData({...formData, parte: e.target.value})} /></Col>
                                <Col md={6}>
                                    <Form.Label className="fw-bold">13. LADO DO CORPO</Form.Label>
                                    <Form.Select value={formData.lado} onChange={e => setFormData({...formData, lado: e.target.value})}>
                                        <option value="N/A">NÃO SE APLICA</option>
                                        <option value="ESQUERDO">ESQUERDO</option>
                                        <option value="DIREITO">DIREITO</option>
                                    </Form.Select>
                                </Col>
                                <Col md={6}>
                                    <Form.Label className="fw-bold">14. NECESSÁRIO ATENDIMENTO MÉDICO EXTERNO?</Form.Label>
                                    <Form.Select value={formData.medico_externo} onChange={e => setFormData({...formData, medico_externo: e.target.value})}>
                                        <option value="NÃO">NÃO</option>
                                        <option value="SIM">SIM</option>
                                    </Form.Select>
                                </Col>
                                <Col md={12}>
                                    <Form.Label className="fw-bold">15. ANEXE IMAGENS (MÁX 5)</Form.Label>
                                    <Form.Control type="file" multiple accept="image/*" onChange={handleFileChange} />
                                    <small className="text-muted">Imagens convertidas: {fotosBase64.length}</small>
                                </Col>
                            </Row>

                            <Button type="submit" variant="success" className="w-100 mt-5 py-3 fw-bold shadow-sm" disabled={loading || loadingUser}>
                                {loading ? <Spinner animation="border" size="sm" /> : "ENVIAR COMUNICADO"}
                            </Button>
                        </Form>
                    </Card.Body>
                </Card>
            </Container>
            <Footer />
        </div>
    );
}

export default ComunicadoOcorrencia;